import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import { customersSortOptions } from 'appConstants';
import { SortAndCountDropdown } from 'components/SortAndCountDropdown/SortAndCountDropdown';

export const SortAndCount: React.FC = () => {
	const { sortBy, countOfItems, setSortBy, setCountOfItems } = useContext<ICustomersContext>(CustomersContext);

	return (
		<SortAndCountDropdown
			sortBy={sortBy}
			sortOptions={customersSortOptions}
			countOfItems={countOfItems}
			testId="SortAndCountDropdown"
			onSortByChange={setSortBy}
			onCountOfItemsChange={setCountOfItems}
		/>
	);
};
